import { action, computed } from 'mobx'
import { type CallCenterMembershipItem } from './CallCenterSelectionViewModel'

/**
 * What the client's workspace entries let the agent do.
 */
export interface CallCenterMembershipItemActions {
  createJob: (item: CallCenterMembershipItem) => void
  inviteToWorkspace: (item: CallCenterMembershipItem) => void
}

/**
 * A workspace the selected client is a member of, or signed up for the
 * waitlist of.
 */
export class CallCenterMembershipItemViewModel {
  constructor(
    readonly item: CallCenterMembershipItem,
    private readonly _canInvite: () => boolean,
    private readonly _actions: CallCenterMembershipItemActions,
  ) {}

  @computed
  get workspaceName() {
    return this.item.workspace?.name || `Workspace ${this.item.workspaceId}`
  }

  @computed
  get lastSeen() {
    return this.item.member?.lastSeen ?? null
  }

  @computed
  get canCreateJob() {
    return Boolean(this.item.workspace && this.item.member)
  }

  @computed
  get isInviteDisabled() {
    return !this._canInvite() || this.item.loading
  }

  @action.bound
  createJob() {
    this._actions.createJob(this.item)
  }

  @action.bound
  invite() {
    this._actions.inviteToWorkspace(this.item)
  }
}
